const fixBlocks = document.querySelectorAll('.fixed');
const toggleScroll = {
	lockPadding: () => {
		let paddingOffset = window.innerWidth - document.body.offsetWidth + 'px';
		fixBlocks.forEach((el) => {
			el.style.paddingRight = paddingOffset;
		});
		document.body.style.paddingRight = paddingOffset;
	},

	unlockPadding: () => {
		fixBlocks.forEach((el) => {
			el.style.paddingRight = '0px';
		});
		document.body.style.paddingRight = '0px';
	},
	// disable/enable scroll
	disableScroll: () => {
		/*let pagePosition = window.scrollY;
		lockPadding();
		document.body.classList.add('_disable-scroll');
		document.body.dataset.position = pagePosition;
		document.body.style.top = -pagePosition + 'px';*/
		lockPadding();
		const scrollY = document.documentElement.style.getPropertyValue('--scroll-y');
		const body = document.body;
		body.style.position = 'fixed';
		body.style.top = `-${scrollY}`;
	},

	enableScroll: () => {
		/*let pagePosition = parseInt(document.body.dataset.position, 10);
		unlockPadding();
		document.body.style.top = 'auto';
		document.body.classList.remove('_disable-scroll');
		window.scroll({ top: pagePosition, left: 0 });
		document.body.removeAttribute('data-position');*/
		unlockPadding();
		const body = document.body;
		const scrollY = body.style.top;
		body.style.position = '';
		body.style.top = '';
		window.scrollTo(0, parseInt(scrollY || '0') * -1);
	},
}

/**
 * disableScroll: () => {
		document.body.dataset.scrollY = window.scrollY;
		const scrollWidth = window.innerWidth - document.body.offsetWidth;
		const styles = `
		position: fixed;
		top: -${window.scrollY}px;
		left: 0;
		width: 100vw;
		padding-right: ${scrollWidth}px;
		`;
		document.body.style.cssText = styles;
		document.querySelector('.header').style.cssText = styles;
	},
	enableScroll: () => {
		document.body.style.cssText = '';
		document.querySelector('.header').style.cssText = '';
		window.scroll({
			top: document.body.dataset.scrollY
		});
	},
 */

export const disableScroll = toggleScroll.disableScroll;
export const enableScroll = toggleScroll.enableScroll;
export const lockPadding = toggleScroll.lockPadding;
export const unlockPadding = toggleScroll.unlockPadding;